import { AdFormat } from '../config/platforms';
import { AdScene } from '../model/types';
import { scaleElements } from './scene';

/**
 * Przenosi kreację na inny format.
 *
 * Elementy skalujemy jednym współczynnikiem i dosuwamy do środka (patrz
 * `scaleElements`), a tło zostaje bez zmian, bo kolor i gradient nie zależą od
 * proporcji. Wynik jest punktem wyjścia, nie gotowcem: przy dużej zmianie
 * proporcji, na przykład z kwadratu na baner, układ prawie zawsze wymaga
 * ręcznego dociągnięcia.
 */
export const adaptSceneToFormat = (
  scene: AdScene,
  platformId: string,
  format: AdFormat,
): AdScene => ({
  platformId,
  formatId: format.id,
  width: format.width,
  height: format.height,
  background: { ...scene.background },
  elements: scaleElements(
    scene.elements,
    { width: scene.width, height: scene.height },
    { width: format.width, height: format.height },
  ),
});
